import { Alert, Platform } from 'react-native';

interface AlertButton {
  text: string;
  style?: 'default' | 'cancel' | 'destructive';
  onPress?: () => void;
}

/**
 * Cross-platform alert that works on iOS, Android, and Web
 */
export const CrossPlatformAlert = {
  alert: (title: string, message?: string, buttons?: AlertButton[]) => {
    if (Platform.OS === 'web') {
      // For web, use window.confirm for destructive actions or window.alert for simple messages
      if (buttons && buttons.length > 1) {
        // Check if there's a destructive/confirm action
        const destructiveButton = buttons.find(
          b => b.style === 'destructive' || (b.style !== 'cancel' && b.onPress)
        );
        const cancelButton = buttons.find(b => b.style === 'cancel');

        const confirmMessage = message ? `${title}\n\n${message}` : title;
        const confirmed = window.confirm(confirmMessage);

        if (confirmed && destructiveButton?.onPress) {
          destructiveButton.onPress();
        } else if (!confirmed && cancelButton?.onPress) {
          cancelButton.onPress();
        }
      } else if (buttons && buttons.length === 1) {
        // Single button - just show alert and call onPress
        window.alert(message ? `${title}\n\n${message}` : title);
        const firstButton = buttons[0];
        if (firstButton?.onPress) {
          firstButton.onPress();
        }
      } else {
        // No buttons - just show alert
        window.alert(message ? `${title}\n\n${message}` : title);
      }
    } else {
      // On native platforms, use the standard Alert
      Alert.alert(title, message, buttons);
    }
  },
};
